/* eslint-disable consistent-return */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Intake, { SECONDARY_THEME } from 'new-ui/Components/Intake';
import { INTERCOM_EVENTS } from 'modules/intercom/intercom';
import { PopupTitle } from 'new-ui/Components/Popup';
import { getUserConditionProfile, getUserCondition } from 'modules/user/utils';
import { useTranslation } from 'utils/modifiedTranslation';
import app from 'new-ui/app';
import inContextEvents, {
  GA_CATEGORY_NAME,
} from 'modules/ga/inContextEvents';
import './MissingCriticalInformation.css';
import { filterQuestionsByCondition } from 'new-ui/functions';

const MissingCriticalInformation = (props) => {
  const { trial, source } = props;
  let { questions } = props;

  if (!questions) {
    questions = trial
      ? trial.missed_questions
      : [
        ...new Set(app.trials.reduce((a, b) => a.concat(b.missed_questions), [])),
        ...new Set(app.treatments ? app.treatments.reduce((a, b) => a.concat(b.missed_questions), []) : null),
      ];
  }
  questions = [...new Set(questions)];
  const [filteredQuestions, setFilteredQuestions] = useState(questions);
  useEffect(() => {
    const filterQuestions = async () => {
      const filtered = await filterQuestionsByCondition({
        questionsIds: questions,
        condition: getUserCondition(app?.user),
        conditionProfile: getUserConditionProfile(app?.user),
      });
      setFilteredQuestions(filtered);
    };
    filterQuestions();
    // eslint-disable-next-line
  }, []);
  questions = filteredQuestions;

  const { t } = useTranslation();
  const { eventName, getMetaData } = inContextEvents.popupInContextDisplayed;
  app.sendGoogleAnalyticsEvent(
    GA_CATEGORY_NAME,
    eventName,
    getMetaData(filteredQuestions.length),
  );

  app.onpopupclose = () => {
    app.intercom.sendEvent(INTERCOM_EVENTS.MISSING_CRITICAL_INFORMATION.POPUP_SUCCESS, { source });
  };

  return (
    <div className="missing-critical-information-popup">
      <PopupTitle title={t('missing_critical.title')} />
      <Intake
        id="missingCriticalInformationPopup"
        theme={SECONDARY_THEME}
        user={app.user}
        customQuestions={questions}
        onUpdate={async (user) => {
          app.showPreloader();
          await app.handleUserUpdate({ data: user });
          app.hidePreloader();
          app.setPopup(false);
        }}
      />
    </div>
  );
};

MissingCriticalInformation.propTypes = {
  trial: PropTypes.object,
  questions: PropTypes.array,
  source: PropTypes.string,
};

export default MissingCriticalInformation;
